<template>
  <div class="list">
    <div
      v-for="(item, index) in notificationsList"
      :key="item.id"
      class="list__item"
      :ref="el => observeNotification(el, item)"
    >
      <NotificationItem :data="item" />
    </div>
    <div class="list__ldr" v-if="isLoadingNextPage">
      <LoaderCircle :color="'var(--circle-loader)'" />
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { observeOnce } from '@/Groups/Notifications/private/imports/intersectionObserver';
  //------------------------------
  import { useNotificationsState } from '@/Groups/Notifications/private/composables/computedValues';
  import { LoaderCircle } from '@/Groups/Notifications/private/imports/externalTemplates';
  import NotificationItem from '@/Groups/Notifications/private/ui/NotificationItem/NotificationItem.vue';
  //------------------------------
  const store = useStore();
  //------------------------------
  const { notificationsList, isLoadingNextPage } = useNotificationsState();
  //------------------------------
  const observeNotification = (el, item) => {
    if (!el || item.is_read_modal_window) return;
    observeOnce(el, () => {
      store.dispatch('Notifications/markNotificationAsRead', item.id);
    });
  };
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>